import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import Callback from '@/components/Callback';
import useOfferTags from '@/hooks/useOfferTags';
import TagTypes from '@/constants/TagTypes';
import { useUser } from '@lore/auth';
import useRouter from '@/hooks/useRouter';

Layout.propTypes = {
  offer: PropTypes.shape({}).isRequired
};

export default function Layout(props) {
  const { offer } = props;

  const currentUser = useUser();
  const router = useRouter();

  const offerSubjects = useOfferTags(offer, TagTypes.Subject);

  if (offerSubjects.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Callback
      callback={() => router.navigate({
        pathname: `/invite`,
        search: queryString.stringify({
          subjects: offerSubjects.data.map(offerSubject => offerSubject._tag.id).join(','),
          locationCondition: JSON.stringify({
            address: currentUser.data.zipCode,
            latitude: currentUser.data.latitude,
            longitude: currentUser.data.longitude,
            radius: 50
          })
        })
      }, { replace: true })}
    />
  );
}
